import currency from 'currency.js';
import { Table } from 'react-bootstrap';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { formatTransactiontDate } from '../../../helpers/date/date';
import { fetchReversedTransactionStart } from '../../../store/actions/WalletAction';

import NothingHere from '../../../images_new/icon/nothing_here.svg?react';

const ReversedEarnings = () => {
  const dispatch = useDispatch()
  const reversedTransactions = useSelector((state) => state.wallet.reversedTransactions);

  useEffect(() => {
    dispatch(fetchReversedTransactionStart());
  }, []);

  return (
    <div>
      <div className='security statement'>
        <div className='trans-table-sec'>
          <div className='trans-table'>
            <Table bordered={false} borderless={true} responsive>
              <thead>
                <tr>
                  <th>REVERSED ON</th>
                  <th>PAID ON</th>
                  <th>DESCRIPTION</th>
                  <th>REASON</th>
                  <th>AMOUNT</th>
                </tr>
              </thead>
              {reversedTransactions?.data && reversedTransactions?.data.length ? (
                <tbody>
                  {reversedTransactions?.data.map((transaction) => {
                    return (
                      <tr key={transaction.id}>
                        <td>{formatTransactiontDate(transaction.created_at)}</td>
                        <td>{formatTransactiontDate(transaction?.wallet_payment?.paid_date)}</td>
                        <td>
                          <span dangerouslySetInnerHTML={{ __html: transaction?.wallet_payment?.message }}></span>
                        </td>
                        <td>{transaction.message}</td>
                        <td>{currency(transaction?.wallet_payment?.user_amount || 0).format()}</td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td colSpan={5}>
                      <div className='mt-3 nothing_here'>
                        <NothingHere />
                      </div>
                    </td>
                  </tr>
                </tbody>
              )}
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReversedEarnings;
